import { Toolbar, ToolbarProps } from '@mui/material';

const ToolbarWrapper: React.FC<ToolbarProps> = ({ children, ...props }) => <Toolbar {...props}>{children}</Toolbar>;

export default ToolbarWrapper;
